<template>
  <section class="pa-section pa-section-pre-registration-message">
    <div class="success-icon">
      <PreRegistrationLogo />
      <p class="caption">ご参加ありがとうございます。</p>
    </div>

    <div class="message-field">
      <p>異界舞踏会・アキバトリカルへご参加頂きまして誠にありがとうございます。</p>
      <p>只今、試験運用中でございますゆえ、一部機能がご利用いただけませんが、何卒ご了承の程宜しく申し上げます。</p>
    </div>
  </section>
</template>

<script>
import PreRegistrationLogo from '@/components/Pages/Home/PreRegistrationMessage/Images/success_registration.svg?inlineN'

export default {
  name        : 'PreRegistrationMessage',
  components  : {
    PreRegistrationLogo
  },
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

.pa-section{
  &-pre-registration-message{
    text-align: center;
    color:#0f0f0f;
    padding-bottom:1rem;

    div.success-icon{
      margin:1rem .8rem 0;
      border-bottom:.24rem solid #c8b197;

      svg{
        display: inline;
        width:5rem;
        height:5rem;
      }

      p.caption{
        font-size:1.3rem;
        margin-top:.4rem;
        margin-bottom:.3rem;
        font-weight: bold;
        
        @include until(375px) {
          font-size:1.1rem;
        }
      }

      @media screen and (min-width: $desktop) {
        svg{
          width:100px;
          height: 100px;
        }

        p.caption{
          font-size:1.6rem;
        }
      }
    }

    div.message-field{
      font-size: .9rem;
      font-weight: bold;
      margin:.3rem .8rem 0;
      padding:.1rem;

      p{
        margin-bottom:.2rem;
      }

      @media screen and (min-width: $desktop) {
        font-weight: normal;
        font-size:1.1rem;
      }

      @include until(375px) {
        font-size: .7rem;
      }
    }
  }
}
</style>
